import React from 'react';
import './Header.css'
import SearchIcon from '@material-ui/icons/Search';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import {Link} from 'react-router-dom';
import {useStateValue} from './StateProvider';

function Header() {
    const[{basket},dispatch]=useStateValue();
    
    return (
        <div className="header">
            <Link to="/">
            <img className="header__logo"
            src={"assets/logo.png"}
             alt="logo"/>
            </Link>

            <div className="header__dropdown">
               <div class="btn-group">
                   <button class="btn dropdown-toggle" type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true"
                           aria-expanded="false">
                               <span>Categories</span>
                   </button>
                   <div class="dropdown-menu dropdown-menu-left p-0" aria-labelledby="triggerId">
                       <a class="dropdown-item" href="#">Women's Fashion</a>
                       <a class="dropdown-item" href="#">Men's Fashion</a>
                       <a class="dropdown-item" href="#">Phones & Telecomunication</a>
                       <a class="dropdown-item" href="#">Jewelry & Watches</a>
                       <a class="dropdown-item" href="#">Home & Pet</a>
                       <a class="dropdown-item" href="#">Bags & Shoes</a>
                   </div>
               </div>
            </div>
           
        
            <div className="header__search">
                <input
                className="header__searchInput"
                type="text"/>
                <SearchIcon className="header__SearchIcon"/>
            </div>
            <div className="header__nav">
                <div className="header__option">
                   <span className="header__optionLineOne">
                       Hello Guest
                   </span>
                   <span className="header__optionLineTwo">
                       Sign In
                   </span>
                </div>
                <div className="header__option">
                   <span className="header__optionLineOne">
                       Returns
                   </span>
                   <span className="header__optionLineTwo">
                       & Orders
                   </span>
                </div>
                <div className="header__option">
                   <span className="header__optionLineOne">
                       Your
                   </span>
                   <span className="header__optionLineTwo">
                       Prime
                   </span>
                </div>
                <div className="header__optionWishList ">
                 <FavoriteBorderIcon/>
                 <span className="header__optionLineTwo 
                 header__wishListCount">
                     0
                 </span>
                </div>
                <Link to="/checkout">
                <div className="header__optionBasket">
                 <ShoppingCartIcon/>
                 <span className="header__optionLineTwo 
                 header__basketCount">
                     {basket?.length}
                 </span>
                </div>
                </Link>
            </div>
        </div>



        
    )
}


export default Header
